const ACCURACY = 100;

export const minutesToHours = (minutes: number): number => Math.round((minutes / 60) * ACCURACY) / ACCURACY;

export const hoursToMinutes = (hours: number): number => hours * 60;
